import {
  createApp
} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/main.css'
import './css/main.css'
import createAxiosInstance from './api/request';
import {
  createPinia
} from 'pinia'
import VueQrcode from 'vue-qrcode';

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// 添加 ResizeObserver 重写代码
if (window.ResizeObserver) {
  const originalRO = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends originalRO {
    constructor(callback) {
      const wrappedCallback = (entries, observer) => {
        // 用requestAnimationFrame避免同步触发
        requestAnimationFrame(() => {
          callback(entries, observer);
        });
      };
      super(wrappedCallback);
    }
  };
}

const app = createApp(App)
app.component('qrcode', VueQrcode);
app.use(ElementPlus)
app.use(createPinia())
const request = createAxiosInstance(router);
app.config.globalProperties.$request = request;
// 导出 request 实例，供 API 文件使用
export {
  request
};

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(store).use(router).mount('#app')
